import { render, staticRenderFns } from "./Pagode.vue?vue&type=template&id=c476db1c&scoped=true&lang=pug&"
import script from "./Pagode.vue?vue&type=script&lang=js&"
export * from "./Pagode.vue?vue&type=script&lang=js&"
import style0 from "./Pagode.vue?vue&type=style&index=0&id=c476db1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c476db1c",
  null
  
)

export default component.exports
import {QPage,QBtn,QDialog,QCard,QCardSection,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtn,QDialog,QCard,QCardSection,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
